

require("../css/app.less");
var _logger = require("xo-beaver/dist/logger");
var _route = require("pages/xo-checkout/route");
var _route2 = require("pages/xo-guest-upgrade/route");
var _middleware = require("js/lib/middleware");
var _index = require("squid/dist/index");
_logger.$logger.info('checkout_fpti', {
  from: 'billing',
  to: 'prepare_app_load'
});
_logger.$logger.info('app_bootstrap', {
  hash: window.location.hash
});
if (_index.$util.param('data')) {
  var guestUpgradeRoute = new _route2.$GuestUpgradeRoute();
  guestUpgradeRoute.bootstrap('guestupgrade', _middleware.$Middleware);
} else {
  var baseRoute = new _route.$BaseRoute();
  baseRoute.bootstrap('checkout.landing', _middleware.$Middleware);
}
window.bootstrap = true;
_logger.$logger;
_route.$BaseRoute;
_route2.$GuestUpgradeRoute;
_middleware.$Middleware;
_index.$util;


//////////////////
// WEBPACK FOOTER
// ./js/app.js
// module id = ./js/app.js
// module chunks = 0